/**
 * Amplitude plugin for event enrichment
 */ import { AMPLITUDE_EVENT_PREFIX, AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT, AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH, PAGE_VIEWED_EVENT_NAME } from './constants';
import { getBrowserDetails } from './browser-detection';
import { getOptimizelyExperimentData } from './optimizely';
// Store the latest page view event
let lastPageViewEvent = null;
/**
 * Creates a unified plugin that enriches all events with additional data
 * - For page view events: saves the entire event for later reference
 * - For component viewed events: adds the page_view property with stored page view event data
 * - For all events: adds optimizely_data and browser_details
 */ export function createUnifiedAmplitudePlugin() {
    return {
        name: 'unified-amplitude-plugin',
        type: 'enrichment',
        setup: async ()=>{
        // No setup needed
        },
        execute: async (event)=>{
            // Get enrichment data for all events
            const optimizelyData = getOptimizelyExperimentData();
            const browserDetails = getBrowserDetails();
            // Case 1: Page view event - store it and add viewport data
            if (event.event_type === PAGE_VIEWED_EVENT_NAME) {
                event.event_properties = {
                    ...event.event_properties,
                    [AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT]: window.innerHeight || undefined,
                    [AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH]: window.innerWidth || undefined,
                    optimizely_data: optimizelyData,
                    browser_name: browserDetails.name,
                    browser_version: browserDetails.version
                };
                lastPageViewEvent = event;
                return event;
            }
            // Case 2: Component events - inherit page view properties
            if (!event.event_type.startsWith(AMPLITUDE_EVENT_PREFIX) && lastPageViewEvent) {
                return {
                    ...event,
                    event_properties: {
                        ...lastPageViewEvent.event_properties,
                        ...event.event_properties,
                        optimizely_data: optimizelyData,
                        browser_name: browserDetails.name,
                        browser_version: browserDetails.version
                    }
                };
            }
            // Case 3: All other events - add enrichment data
            return {
                ...event,
                event_properties: {
                    ...event.event_properties,
                    optimizely_data: optimizelyData,
                    browser_name: browserDetails.name,
                    browser_version: browserDetails.version
                }
            };
        }
    };
}
/**
 * Retrieves the current Amplitude page view event if available
 */ export function getCurrentAmplitudePageView() {
    return lastPageViewEvent;
}
/**
 * Reset the page view event (useful for testing)
 * @internal
 */ export function resetPageViewEvent() {
    lastPageViewEvent = null;
}
